import { CopyData } from '../../types';

const initialState: any = null;

interface ReduxProps {
  type: string;
  value: CopyData | null;
}

export default (state = initialState, { type, value }: ReduxProps): CopyData => {
  switch (type) {
    case 'SET_COPY_DATA':
      return {
        ...state,
        ...value
      };
    default:
      return state;
  }
};
